import { OrbitSuccess } from '#components/atoms/illustrations/OrbitSuccess.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

export function SignupSuccess() {
  return (
    <AuthLayout centerVertically={true}>
      <CenteredLayout Illustration={OrbitSuccess} preventNotifications={true}>
        <h2>Account created, check your email</h2>
        {/* Demo-only shortcut: there's no real inbox when the API is mocked, so let the
            magic link be "clicked" directly to walk through the rest of the flow. */}
        {__IS_MOCKED__ ?
          <p className="p-md mt-16">
            <Link className="a" to="/auth/magic-link?token=demo&email=demo@defined.net">
              Continue (demo)
            </Link>
          </p>
        : null}
      </CenteredLayout>
    </AuthLayout>
  );
}
